import { EnumNavigationBar, useNavigation } from '@Contexts/navigation';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const NavigationUpdater = () => {
    const location = useLocation();
    const { setNavigationBar } = useNavigation();

    useEffect(() => {
        if (location.pathname.includes('settings') || location.pathname.includes('mailing')) {
            setNavigationBar(EnumNavigationBar.Settings);
        } else if (location.pathname.includes('profile')) {
            setNavigationBar(EnumNavigationBar.Profile);
        } else {
            setNavigationBar(EnumNavigationBar.Main);
        }
    }, [location.pathname, setNavigationBar]);

    return undefined;
};
